import * as Vue from 'vue';
import * as VueRouter from 'vue-router';
import store from '@/store';

const DEFAULT_TITLE = 'Sentry-SECURE Admin Portal';

const router = VueRouter.createRouter({
  history: VueRouter.createWebHashHistory(),
  mode: 'history',
  base: import.meta.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'welcome',
      component: () => import('../views/Welcome.vue'),
      meta: { title: `Welcome | ${DEFAULT_TITLE}` },
    },
    {
      path: '/changepassword',
      name: 'changepassword',
      component: () => import('../views/Welcome.vue'),
      meta: { title: `Welcome | ${DEFAULT_TITLE}` },
    },
    {
      path: '/support',
      name: 'support',
      component: () => import('../views/Support.vue'),
      meta: { title: `Support | ${DEFAULT_TITLE}` },
    },
    {
      path: '/devices',
      name: 'devices',
      component: () => import('../views/Devices/Index.vue'),
      meta: {
        title: `Devices | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, ownerOnly, blockImageViewer],
      },
    },
    {
      path: '/devices/add',
      name: 'add-device',
      component: () => import('../views/Devices/Create.vue'),
      meta: {
        title: `Add Device | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, ownerOnly, blockImageViewer],
      },
    },
    {
      path: '/devices/:id',
      name: 'device-detail',
      props: true,
      component: () => import('../views/Devices/Detail.vue'),
      meta: {
        title: `Device Detail | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/devices/:id/edit',
      name: 'device-edit',
      props: true,
      component: () => import('../views/Devices/Form.vue'),
      meta: {
        title: `Device Edit | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, ownerOnly, blockImageViewer],
      },
    },
    {
      path: '/connections',
      name: 'connections',
      component: () => import('../views/Connections/Index.vue'),
      meta: {
        title: `Connections | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/connections/create',
      name: 'connection-create',
      component: () => import('../views/Connections/Create.vue'),
      meta: {
        title: `Connection Create | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/connections/:id',
      name: 'connection-detail',
      props: true,
      component: () => import('../views/Connections/Detail.vue'),
      meta: {
        title: `Connection Detail | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/connections/:id/edit',
      name: 'connection-edit',
      props: true,
      component: () => import('../views/Connections/Form.vue'),
      meta: {
        title: `Connection Edit | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/events',
      name: 'events',
      props: true,
      component: () => import('../views/Events/Index.vue'),
      meta: { title: `Events | ${DEFAULT_TITLE}`, middleware: [blockDispatcher, blockImageViewer] },
    },
    {
      path: '/events/:id',
      name: 'event-detail',
      props: true,
      component: () => import('../views/Events/Detail.vue'),
      meta: {
        title: `Event Detail | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/accounts',
      name: 'accounts',
      component: () => import('../views/Accounts/Index.vue'),
      meta: {
        title: `Accounts | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/accounts/add',
      name: 'add-account',
      component: () => import('../views/Accounts/Create.vue'),
      meta: {
        title: `Add Account | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/accounts/:id',
      name: 'account-detail',
      props: true,
      component: () => import('../views/Accounts/Detail.vue'),
      meta: {
        title: `Account Detail | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/accounts/:id/edit',
      name: 'account-edit',
      props: true,
      component: () => import('../views/Accounts/Form.vue'),
      meta: {
        title: `Account Edit | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/instructions',
      name: 'instruction-edit',
      component: () => import('../views/Instructions/Form.vue'),
      meta: {
        title: `Instructions Edit | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/training-create',
      name: 'training-create',
      component: () => import('../views/Training/CreateTraining.vue'),
      meta: {
        title: `Training Create | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
        {
      path: '/training-scenarios',
      name: 'training-scenarios',
      component: () => import('../views/Training/ConfigureScenario.vue'),
      meta: {
        title: `Training Scenarios | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/nonRMSEvents',
      name: 'non-rms-event-create',
      props: true,
      component: () => import('../views/nonRMSEvents/Create.vue'),
      meta: { title: `Banner and Emails | ${DEFAULT_TITLE}` },
    },
    {
      path: '/downloads',
      name: 'downloads',
      component: () => import('../views/Downloads/Index.vue'),
      meta: {
        title: `Downloads | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/configuration/:id',
      name: 'configuration-detail',
      props: true,
      component: () => import('../views/Configuration/Detail.vue'),
      meta: {
        title: `Configuration Detail | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/configuration/:id/edit',
      name: 'configuration-edit',
      component: () => import('../views/Configuration/Form.vue'),
      meta: {
        title: `Configuration Edit | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/media/owners/:ownerId/devices/:deviceId',
      name: 'media-device-live-feed',
      props: true,
      component: () => import('../views/Media/LiveFeed.vue'),
      meta: { title: `Device Live Feed | ${DEFAULT_TITLE}`, middleware: [blockDispatcher] },
    },
    {
      path: '/media/events/:eventId/owners/:ownerId/devices/:deviceId',
      name: 'media-event-live-feed',
      props: true,
      component: () => import('../views/Media/LiveFeed.vue'),
      meta: { title: `Device Live Feed | ${DEFAULT_TITLE}`, middleware: [blockDispatcher] },
    },
    {
      path: '/summary',
      name: 'summary',
      component: () => import('../views/Summary/Form.vue'),
      meta: {
        title: `Summary | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, ownerOnly, blockImageViewer],
      },
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('../views/Users/Index.vue'),
      meta: {
        title: `Users | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/users/conditions',
      name: 'user-conditions',
      component: () => import('../views/Users/ConditionsView.vue'),
      meta: {
        title: `User Conditions | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/sso',
      name: 'sso',
      component: () => import('../views/SSO/Form.vue'),
      meta: {
        title: `SSO | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, consumerOnly, blockImageViewer],
      },
    },
    {
      path: '/users/subgroups',
      name: 'user-subgroups',
      component: () => import('../views/Users/Subgroups.vue'),
      meta: {
        title: `Sub Group Management | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, consumerOnly, blockImageViewer],
      },
    },
    {
      path: '/users/bulkedit',
      name: 'user-bulkedit',
      component: () => import('../views/Users/BulkEdit.vue'),
      meta: {
        title: `Bulk Edit | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/users/:id',
      name: 'edit-user',
      props: true,
      component: () => import('../views/Users/Form.vue'),
      meta: {
        title: `Edit User | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, blockImageViewer],
      },
    },
    {
      path: '/backend-subscriber-configuration',
      name: 'backend-subscriber-edit-configuration',
      component: () => import('../views/BackendSubcriberConfiguration/Form.vue'),
      meta: {
        title: `Computer Aided Dispatch Configuration | ${DEFAULT_TITLE}`,
        middleware: [blockDispatcher, consumerOnly, blockImageViewer],
      },
    },
    {
      path: '/event-dispatcher',
      name: 'event-dispatcher',
      component: () => import('../views/Dispatch/Dispatcher.vue'),
      meta: {
        title: `Event Dispatcher | ${DEFAULT_TITLE}`,
        middleware: [consumerOnly, blockImageViewer],
      },
    },
    {
      path: '/:pathMatch(.*)*',
      name: '404',
      component: () => import('../views/Error404.vue'),
    },
    {
      path: '/404',
      name: 'not-found',
      component: () => import('../views/Error404.vue'),
    },
  ],
});

function blockDispatcher(store) {
  return !(store.getters.currentUserAccountType === 'Dispatcher');
}

function blockImageViewer(store) {
  return !(store.getters.currentUserAccountType === 'ImageViewer');
}

function ownerOnly(store) {
  return store.getters.currentUserIsOwner;
}

function consumerOnly(store) {
  return store.getters.currentUserIsConsumer;
}

router.beforeResolve(async (to, _, next) => {
  if (!to.meta.middleware) {
    return next();
  }

  // currentUser is updated asynchronously, so
  // in order to have the necessary user information to
  // use the middleware, we need to wait for the information
  // to be there.
  await store.dispatch('updateCurrentUser');
  for (let cb of to.meta.middleware) {
    if (!cb(store)) {
      return next({
        name: '404',
      });
    }
  }
  return next();
});

router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router;
